import React from "react";
import SunkenPanel from "../components/SunkenPanel";

const README = `THINGS TO DO HERE
-----------------
  * Drag, resize, and minimize the windows.
  * Watch saylo.wmv, a demo of my app, Saylo.
  * Play las palomitas.mp3 + grab a salsa partner.
  * Play Minesweeper. Beat 999 seconds.

THINGS TO NOT DO HERE
---------------------
  * Look at my recycle bin.

(Edits to this file are not persisted to disk or cloud.
Go wild.)
`;

const Notepad = () => (
  <div className="flex flex-col h-full">
    <div className="flex-1 min-h-0">
      <SunkenPanel>
        <textarea
          className="w-full h-full p-1 resize-none outline-none font-mono text-[0.85rem] leading-[1.2rem] whitespace-pre"
          defaultValue={README}
          spellCheck={false}
          aria-label="readme.txt"
        />
      </SunkenPanel>
    </div>
  </div>
);

export default Notepad;
